import { render } from "./Beauty.vue?vue&type=template&id=ee88e88a&scoped=true"
import script from "./Beauty.vue?vue&type=script&lang=js"
export * from "./Beauty.vue?vue&type=script&lang=js"

import "./Beauty.vue?vue&type=style&index=0&id=ee88e88a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee88e88a"],['__file',"src/apps/quiz/routes/Beauty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee88e88a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee88e88a', __exports__)) {
    api.reload('ee88e88a', __exports__)
  }
  
  module.hot.accept("./Beauty.vue?vue&type=template&id=ee88e88a&scoped=true", () => {
    api.rerender('ee88e88a', render)
  })

}


export default __exports__